<template>
    <div class="view-product-orders">
        <orders-table
            ref="ordersTable"
            @closePopup="treatUnusedMethods"
        ></orders-table>
    </div>
</template>

<script>
    import vSelect from 'vue-select';
    import OrdersTable from "../../chat-attendance/orders/OrdersTable";

    export default {
        components: {
            vSelect,
            OrdersTable
        },
        data() {
            return {
                listStatusName: [],
                search: '',
                orderBy: {
                    name: 'chat_tickets.customers.name',
                    type: 'ASC'
                },
                modalToFinishOrder: false,
                targetToFinish: 0,
                page: 1,
                itemsPerPage: 4,
                isMounted: false
            }
        },
        methods: {
            treatUnusedMethods() {
            },
            async dataLoad() {
                await this.$refs.ordersTable.dataLoad();
            },
        },
        async mounted() {
            await this.dataLoad();
            this.isMounted = true;
        },
        beforeRouteLeave(to, from, next) {
            this.$events.fire('closeAllPopUps')
            setTimeout(() => { next();}, 200)
        },
    }
</script>

<style lang="scss">
    .view-product-orders {
        .con-tablex.vs-table--content {
            width: 102%; 
        }

        .vs-chip--text {
          margin-left: 10px;
        }

        table.vs-table.vs-table--tbody-table {
            border-collapse: separate;
            border-spacing: 0 15px !important;
            padding: 0 1rem;
        }
        thead > tr {
            background-color: transparent !important;
        }
        .vs-table-text {
            text-transform: uppercase;
            font-size: 12px;
        }
        input.input-search.vs-table--search-input {
            height: 45px;
        }
        tbody {
            > tr {
                box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.05%);
                .align-button-flex {
                    .vs-button-text.vs-button--text {
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                        padding-left: 10px;
                    }
                }
                td.vs-table--td:last-of-type {
                    border-top-right-radius: 10px !important; 
                    border-bottom-right-radius: 10px !important;
                }
                .td-check {
                    border-top-left-radius: 10px !important; 
                    border-bottom-left-radius: 10px !important;
                }
            }
            tr.tr-expand {
                > td {
                    border-radius: 10px !important;
                    div.content-tr-expand {
                        justify-content: space-between;
                        align-items: flex-end;
                        .order-infos-div {
                            display: flex;
                            div {
                                border: solid 2px #abb3b257; 
                                border-radius: 14px;
                                cursor: pointer;
                                margin: 8px;
                                width: 90px;
                                height: 80px;
                                display: flex;
                                flex-direction: column;
                                align-content: center;
                                justify-content: center;
                                align-items: center;
                                flex-wrap: wrap;

                                span {
                                    font-size: 10px;
                                    text-align: center;
                                }
                                img {
                                    width: 40px;
                                    height: 40px;
                                    border-radius: 40px;
                                }
                            }
                        }
                        .order-infos-btn {
                            margin-bottom: 8px;
                            button {
                                display: flex;
                                border-radius: 15px;
                                height: 35px;
                                padding: 0px 16px 0px 25px;
                                justify-content: center;
                            }
                            .vs-button-text.vs-button--text {
                                display: flex;
                            }
                            span.vs-button-text.vs-button--text {
                                display: flex;
                                flex-direction: row;
                                justify-content: center;
                                align-items: center;
                            }
                        }
                    }
                }
            }
        }
        select#selectColor {
            background-color: transparent !important;
            border: 0 !important;
            height: 35px; 
            box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
            color: #cabfbf;
            font-weight: bolder;
            font-size: 12px;
            margin: 0;
            letter-spacing: 0.2px;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
            'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
            sans-serif;
        }
        option {
            * {
                line-height: 10px !important;
                height: 100px !important;
                width: 100px !important;
                border-radius: 10px !important;
            }
            font-size: 15px !important;
            border: 0;
            color: black;
            font-weight: 400;
        }
        option:checked {
            font-size: 16px !important;
        }
        #pixResize {
            width: 60px !important;
            height: 23px !important;
        }
        #cardResize {
            border-radius: 0 !important;
            height: 35px !important;
            width: 50px !important;
        }
        #cashResize {
            width: 40px !important;
            height: 30px !important;
        }
    }
</style>